import { Component, OnInit, Input, NgZone } from '@angular/core';
import { SubcomponentVerificationModel } from '../../models/dictionaries/subcomponents-verification.model';
import { InteractionEquationModel } from '../../models/dictionaries/interaction-equation.model';
import { MainPageService } from '../../main-page/main-page.service';
import { Router } from '@angular/router';
import { VariantVerificationModel } from '../../models/parts/variant-verification.model';
import { PageChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { UnitsConverter } from '../units-converter/units-converter';

declare var $: any;
const unitOptions = ['kN/kNm', 'kN/kNcm', 'kip/kip-ft'];

@Component({
  selector: 'app-variant-verification-grid',
  template: `<div style="margin-left: 15px;">
  <kendo-grid style="border: none" [data]="variantsVerificationDisplayData" (add)="addHandlerForVariantVerificationData($event)"
    (save)="saveHandlerForVariantVerificationData($event)" (cancel)="cancelHandlerForVariantVerificationData($event)" (edit)="editHandlerForVariantVerificationData($event)"
    (remove)="removeHandler($event)">
    <ng-template kendoGridToolbarTemplate>

      <div class="display-flex">

        <form style="margin-left: 20px">
          <input type="radio" name="unit" (click)="onUnitChange($event.target.value)" value="kN/kNm" checked> kN/kNm
          <input type="radio" name="unit" (click)="onUnitChange($event.target.value)" value="kN/kNcm"> kN/kNcm
          <input type="radio" name="unit" (click)="onUnitChange($event.target.value)" value="kip/kip-ft"> kip/kip-ft
        </form>


        <button kendoGridAddCommand [disabled]="!canAddRowToVariantVerificationGrid" class="btn add-button light-steel-shadow" style="position: absolute; right: 15px;"
          type="button" title="add">
          <i class="fa fa-plus" click></i> Add</button>
      </div>
    </ng-template>
    <kendo-grid-column field="verificationId" title="Verification" width="120">
      <ng-template kendoGridEditTemplate let-dataItem="dataItem">
        <!-- <input [(ngModel)]="dataItem.ProductName" kendoGridFocusable name="ProductName" class="k-textbox" required/> -->
        <select #verification style="width:120px;" name="VerificationSelect" [(ngModel)]="dataItem.verificationId" required>
          <option *ngFor="let verification of verificationData" [(value)]="verification.name">{{verification.name}}</option>
        </select>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="methodId" title="Method" width="75">
      <ng-template kendoGridEditTemplate let-dataItem="dataItem">
        <!-- <input [(ngModel)]="dataItem.ProductName" kendoGridFocusable name="ProductName" class="k-textbox" required/> -->
        <select #method style="width:70px;" name="VerificationSelect" [(ngModel)]="dataItem.methodId" required>
          <option *ngFor="let method of methodsData" [(value)]="method.name">{{method.name}}</option>
        </select>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="Fx_p" editor="editNumber" title="Fx+" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="Fx_m" editor="editNumber" title="Fx-" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="Fy_p" editor="editNumber" title="Fy+" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="Fy_m" editor="editNumber" title="Fy-" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="Fz_p" editor="editNumber" title="Fz+" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="Fz_m" editor="editNumber" title="Fz-" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="Mx_p" editor="editNumber" title="Mx+" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="Mx_m" editor="editNumber" title="Mx-" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="My_p" editor="editNumber" title="My+" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="My_m" editor="editNumber" title="My-" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="Mz_p" editor="editNumber" title="Mz+" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="Mz_m" editor="editNumber" title="Mz-" width="50">
    </kendo-grid-column>
    <kendo-grid-column field="Vrd" editor="editNumber" title="Vrd" width="50">
    </kendo-grid-column>
    <kendo-grid-column title="" width="60">
      <ng-template kendoGridCellTemplate>
        <div class="display-flex">
          <!--MAGIC DO NOT TOUCH DISABLE FUNCTION-->
          <button kendoGridEditCommand [disabled]="!canAddRowToVariantVerificationGrid" class="attributesBtn" title="Edit">
            <i class="material-icons">&#xE3C9;</i>
          </button>
          <button kendoGridRemoveCommand [disabled]="!canAddRowToVariantVerificationGrid" class="attributesBtn btn-remove" data-toggle="modal"
            data-target="#confirmationModal" title="Remove">
            <i class="material-icons">&#xE5CD;</i>
          </button>
          <button kendoGridSaveCommand class="attributesBtn" title="Save">
            <i class="material-icons">&#xE876;</i>
          </button>
          <button kendoGridCancelCommand class="attributesBtn" title="Cancel">
            <i class="material-icons">&#xE5C9;</i>
          </button>
        </div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>

<script>
  function editNumber(container, options) {
    $('<input data-bind="value:' + options.field + '"/>')
      .appendTo(container)
      .kendoeditNumberTextBox({
        spinners: false
      });
  }
</script>

<!-- Confiramtion Modal -->
<div class="modal" id="confirmationModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <div>
          Do you want to remove this element?
        </div>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-danger save-button" data-dismiss="modal" (click)="removeFromVariantVerificationData()">Remove</button>
      </div>

    </div>
  </div>
</div>`,
  styles: [`input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.display-flex{display:flex;align-items:center;margin-bottom:10px}`]
})

export class VariantVerificationGridComponent implements OnInit {
  private variantId: string;
  private designBaseId: string;
  public variantsVerificationRawData: VariantVerificationModel[];
  public variantsVerificationDisplayData: VariantVerificationModel[];
  public verificationData: SubcomponentVerificationModel[];
  public methodsData: InteractionEquationModel[];

  public formGroup: FormGroup;
  private unitsConverter = new UnitsConverter();

  public variantVerificationPageSize = 5;
  public skipForvariantsVerificationData = 0;
  public editedVariantVerification: VariantVerificationModel;
  public rowNumber: number;
  public variantVerificationGridView: GridDataResult;
  private variantVerificationOpenedRows: number = 0;
  public currentOpenRow: number;
  public isVariantVerificationGridInChangeMode = false;
  public canAddRowToVariantVerificationGrid = true;
  public isVariantVerificationArrayEmpty: any = true;
  public showRemoveDialog: boolean = false;
  private dataCopy: { verification: string, method: string };
  private removeData: any;
  public displayUnitF: string = 'kN';
  public displayUnitM: string = 'kNm';

  @Input() set VariantId(value: string) {
    this.variantId = value;
    this.loadVerificationData();
  }

  @Input() set DesignBaseId(value: string) {
    this.designBaseId = value;
    this.loadVerificationData();
  }


  constructor(private mainPageService: MainPageService, private router: Router, private zone: NgZone,
    private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.loadData();
    this.mainPageService.deleteVariantVerificationSubject.subscribe((value) => {
      this.variantsVerificationRawData = this.variantsVerificationRawData.filter(x => x._id !== value);
      this.variantsVerificationDisplayData = this.variantsVerificationDisplayData.filter(x => x._id !== value);
    });
  }

  loadVerificationData(): void {
    if (this.designBaseId !== null && this.variantId !== null) {
      this.zone.run(() => {
        this.mainPageService.loadVariantVerifications(this.variantId, this.designBaseId).subscribe((response) => {
          this.variantsVerificationRawData = response;
          this.variantsVerificationDisplayData = Array.from(this.variantsVerificationRawData);
          this.changeDisplayedUnits();
        });
      });
    }
  }

  loadData(): void {
    this.mainPageService.loadAllSubcomponentsForVerification().subscribe((response) => {
      this.verificationData = response;
    });
    this.mainPageService.loadAllInteracionEquations().subscribe((response) => {
      this.methodsData = response;
    });
  }

  saveNewVariantVerification() {
    console.log(this.editedVariantVerification);
    this.mainPageService.addNewVariantVerificationIntoDb(
      JSON.stringify(this.variantsVerificationRawData[this.rowNumber])).subscribe((response) => {
        this.editedVariantVerification._id = response;
        this.variantsVerificationRawData[this.rowNumber] = this.editedVariantVerification;
      });
  }

  saveEditedVariantVerification() {
    console.log(this.variantsVerificationRawData[this.rowNumber]);
    this.mainPageService.updateVariantVerificationInDb(JSON.stringify(this.editedVariantVerification)).subscribe((response) => { });
  }

  deleteVariantVerification(variantVerification) {
    this.mainPageService.removeVariantVerification(variantVerification._id).subscribe((res) => { }, (error: any) => { });
    this.mainPageService.deleteVariantVerificationSubject.next(variantVerification._id);
  }

  public editHandlerForVariantVerificationData({ sender, rowIndex, dataItem }) {
    this.canAddRowToVariantVerificationGrid = false;

    this.dataCopy = {
      verification: this.variantsVerificationDisplayData[rowIndex].verificationId,
      method: this.variantsVerificationDisplayData[rowIndex].methodId
    };
    this.variantVerificationOpenedRows++;
    this.isVariantVerificationGridInChangeMode = true;
    this.currentOpenRow = rowIndex;
    this.formGroup = this.createFormGroupForVariantVerificationData(this.variantsVerificationDisplayData[rowIndex]);
    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandlerForVariantVerificationData({ sender, rowIndex }) {
    if (this.isVariantVerificationGridInChangeMode) {
      this.variantVerificationOpenedRows--;
      sender.closeRow(rowIndex);
      if (this.variantVerificationOpenedRows === 0) {
        this.isVariantVerificationGridInChangeMode = false;
      }
      this.variantsVerificationDisplayData[rowIndex].verificationId = this.dataCopy.verification;
      this.variantsVerificationDisplayData[rowIndex].methodId = this.dataCopy.method;
      this.canAddRowToVariantVerificationGrid = true;
    } else {
      this.variantVerificationOpenedRows--;
      this.variantsVerificationDisplayData = this.variantsVerificationDisplayData.filter(
        item => item !== this.variantsVerificationDisplayData[rowIndex]
      );
      sender.closeRow(rowIndex);
      this.canAddRowToVariantVerificationGrid = true;
    }

  }

  public saveHandlerForVariantVerificationData({ sender, formGroup, rowIndex }) {
    this.rowNumber = rowIndex;
    if (this.isVariantVerificationGridInChangeMode) {
      if (
        this.variantsVerificationDisplayData[rowIndex].verificationId !== ''
        && this.variantsVerificationDisplayData[rowIndex].methodId !== ''
        && this.formGroup.valid
      ) {
        this.variantVerificationOpenedRows--;


        this.overwriteDataInGrid(rowIndex, formGroup);
        sender.closeRow(rowIndex);
        this.canAddRowToVariantVerificationGrid = true;
        if (this.variantVerificationOpenedRows === 0) {
          this.isVariantVerificationGridInChangeMode = false;
        }
        this.changeElementUnitsToSI(rowIndex);
        this.editedVariantVerification = this.variantsVerificationRawData[rowIndex];
        this.saveEditedVariantVerification();
      }
    } else {
      if (
        this.variantsVerificationDisplayData[rowIndex].verificationId !== ''
        && this.variantsVerificationDisplayData[rowIndex].methodId !== ''
        && this.formGroup.valid
      ) {
        this.variantVerificationOpenedRows--;


        this.overwriteDataInGrid(rowIndex, formGroup);
        sender.closeRow(rowIndex);
        this.canAddRowToVariantVerificationGrid = true;
        if (this.variantVerificationOpenedRows === 0) {
          this.isVariantVerificationGridInChangeMode = false;
        }
        this.changeElementUnitsToSI(rowIndex);
        this.editedVariantVerification = this.variantsVerificationRawData[rowIndex];
        this.saveNewVariantVerification();
      }

    }

  }

  public addHandlerForVariantVerificationData({ sender }) {
    this.variantVerificationOpenedRows++;
    this.variantsVerificationDisplayData.push(new VariantVerificationModel(this.variantId, this.designBaseId));
    this.canAddRowToVariantVerificationGrid = false;
    this.currentOpenRow = this.variantsVerificationDisplayData.length - 1;
    sender.editRow(
      this.variantsVerificationDisplayData.length - 1,
      this.formGroup = this.createFormGroupForVariantVerificationData(
        this.variantsVerificationDisplayData[this.variantsVerificationDisplayData.length - 1]
      )
    );
  }

  public removeHandler({ sender, dataItem }) {
    this.removeData = dataItem;
  }

  public removeFromVariantVerificationData() {
    let index;
    for (let i = 0; i < this.variantsVerificationDisplayData.length; i++) {
      if (this.variantsVerificationDisplayData[i]._id === this.removeData._id) {
        index = i;
      }
    }
    this.deleteVariantVerification(this.variantsVerificationDisplayData[index]);
  }

  public onUnitChange(unit) {
    if (unit === 'kN/kNm') {
      this.displayUnitF = 'kN';
      this.displayUnitM = 'kNm';
    } else if (unit === 'kN/kNcm') {
      this.displayUnitF = 'kN';
      this.displayUnitM = 'kNcm';
    } else if (unit === 'kip/kip-ft') {
      this.displayUnitF = 'kip';
      this.displayUnitM = 'kip-ft';
    }
    this.changeDisplayedUnits();
  }

  private changeDisplayedUnits() {
    let tempObject: VariantVerificationModel;
    for (let index = 0; index < this.variantsVerificationRawData.length; index++) {
      tempObject = {
        _id: this.variantsVerificationRawData[index]._id,
        variantId: this.variantsVerificationRawData[index].variantId,
        designBaseId: this.variantsVerificationRawData[index].designBaseId,
        verificationId: this.variantsVerificationRawData[index].verificationId,
        methodId: this.variantsVerificationRawData[index].methodId,
        Fx_p:  this.unitsConverter.convertFromSIToUnits(
          this.variantsVerificationRawData[index].Fx_p, this.displayUnitF, 4),
        Fx_m: this.unitsConverter.convertFromSIToUnits(
          this.variantsVerificationRawData[index].Fx_m, this.displayUnitF, 4),
        Fy_p: this.unitsConverter.convertFromSIToUnits(
          this.variantsVerificationRawData[index].Fy_p, this.displayUnitF, 4),
        Fy_m: this.unitsConverter.convertFromSIToUnits(
          this.variantsVerificationRawData[index].Fy_m, this.displayUnitF, 4),
        Fz_p: this.unitsConverter.convertFromSIToUnits(
          this.variantsVerificationRawData[index].Fz_p, this.displayUnitF, 4),
        Fz_m: this.unitsConverter.convertFromSIToUnits(
          this.variantsVerificationRawData[index].Fz_m, this.displayUnitF, 4),
        Mx_p: this.unitsConverter.convertFromSIToUnits(
          this.variantsVerificationRawData[index].Mx_p, this.displayUnitM, 4),
        Mx_m: this.unitsConverter.convertFromSIToUnits(
          this.variantsVerificationRawData[index].Mx_m, this.displayUnitM, 4),
        My_p: this.unitsConverter.convertFromSIToUnits(
          this.variantsVerificationRawData[index].My_p, this.displayUnitM, 4),
        My_m: this.unitsConverter.convertFromSIToUnits(
          this.variantsVerificationRawData[index].My_m, this.displayUnitM, 4),
        Mz_p: this.unitsConverter.convertFromSIToUnits(
          this.variantsVerificationRawData[index].Mz_p, this.displayUnitM, 4),
        Mz_m: this.unitsConverter.convertFromSIToUnits(
          this.variantsVerificationRawData[index].Mz_m, this.displayUnitM, 4),
        Vrd: this.variantsVerificationRawData[index].Vrd,
      };
      this.variantsVerificationDisplayData[index] = Object.assign( {}, tempObject);
    }
  }

  private changeElementUnitsToSI(index: number) {
    const tempObject = {
      _id: this.variantsVerificationDisplayData[index]._id,
      variantId: this.variantsVerificationDisplayData[index].variantId,
      designBaseId: this.variantsVerificationDisplayData[index].designBaseId,
      verificationId: this.variantsVerificationDisplayData[index].verificationId,
      methodId: this.variantsVerificationDisplayData[index].methodId,
      Fx_p:  this.unitsConverter.convertFromUnitsToSI(
        this.variantsVerificationDisplayData[index].Fx_p, this.displayUnitF),
      Fx_m: this.unitsConverter.convertFromUnitsToSI(
        this.variantsVerificationDisplayData[index].Fx_m, this.displayUnitF),
      Fy_p: this.unitsConverter.convertFromUnitsToSI(
        this.variantsVerificationDisplayData[index].Fy_p, this.displayUnitF),
      Fy_m: this.unitsConverter.convertFromUnitsToSI(
        this.variantsVerificationDisplayData[index].Fy_m, this.displayUnitF),
      Fz_p: this.unitsConverter.convertFromUnitsToSI(
        this.variantsVerificationDisplayData[index].Fz_p, this.displayUnitF),
      Fz_m: this.unitsConverter.convertFromUnitsToSI(
        this.variantsVerificationDisplayData[index].Fz_m, this.displayUnitF),
      Mx_p: this.unitsConverter.convertFromUnitsToSI(
        this.variantsVerificationDisplayData[index].Mx_p, this.displayUnitM),
      Mx_m: this.unitsConverter.convertFromUnitsToSI(
        this.variantsVerificationDisplayData[index].Mx_m, this.displayUnitM),
      My_p: this.unitsConverter.convertFromUnitsToSI(
        this.variantsVerificationDisplayData[index].My_p, this.displayUnitM),
      My_m: this.unitsConverter.convertFromUnitsToSI(
        this.variantsVerificationDisplayData[index].My_m, this.displayUnitM),
      Mz_p: this.unitsConverter.convertFromUnitsToSI(
        this.variantsVerificationDisplayData[index].Mz_p, this.displayUnitM),
      Mz_m: this.unitsConverter.convertFromUnitsToSI(
        this.variantsVerificationDisplayData[index].Mz_m, this.displayUnitM),
      Vrd: this.variantsVerificationDisplayData[index].Vrd,
    };
    this.variantsVerificationRawData[index] = Object.assign( {}, tempObject);
  }

  overwriteDataInGrid(rowIndex, formGroup) {
    this.variantsVerificationDisplayData[rowIndex].Fx_m = formGroup.value.Fx_m;
    this.variantsVerificationDisplayData[rowIndex].Fx_p = formGroup.value.Fx_p;
    this.variantsVerificationDisplayData[rowIndex].Fy_m = formGroup.value.Fy_m;
    this.variantsVerificationDisplayData[rowIndex].Fy_p = formGroup.value.Fy_p;
    this.variantsVerificationDisplayData[rowIndex].Fz_m = formGroup.value.Fz_m;
    this.variantsVerificationDisplayData[rowIndex].Fz_p = formGroup.value.Fz_p;
    this.variantsVerificationDisplayData[rowIndex].Mx_m = formGroup.value.Mx_m;
    this.variantsVerificationDisplayData[rowIndex].Mx_p = formGroup.value.Mx_p;
    this.variantsVerificationDisplayData[rowIndex].My_m = formGroup.value.My_m;
    this.variantsVerificationDisplayData[rowIndex].My_p = formGroup.value.My_p;
    this.variantsVerificationDisplayData[rowIndex].Mz_m = formGroup.value.Mz_m;
    this.variantsVerificationDisplayData[rowIndex].Mz_p = formGroup.value.Mz_p;
    this.variantsVerificationDisplayData[rowIndex].Vrd = formGroup.value.Vrd;
  }

  public createFormGroupForVariantVerificationData(dataItem: any): FormGroup {
    return this.formBuilder.group({
      _id: dataItem._id,
      variantId: dataItem.variantId,
      designBaseId: dataItem.designBaseId,
      verificationId: dataItem.verificationId,
      methodId: dataItem.methodId,
      Fx_p: new FormControl(dataItem.Fx_p, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      Fx_m: new FormControl(dataItem.Fx_m, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      Fy_p: new FormControl(dataItem.Fy_p, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      Fy_m: new FormControl(dataItem.Fy_m, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      Fz_p: new FormControl(dataItem.Fz_p, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      Fz_m: new FormControl(dataItem.Fz_m, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      Mx_p: new FormControl(dataItem.Mx_p, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      Mx_m: new FormControl(dataItem.Mx_m, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      My_p: new FormControl(dataItem.My_p, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      My_m: new FormControl(dataItem.My_m, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      Mz_p: new FormControl(dataItem.Mz_p, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      Mz_m: new FormControl(dataItem.Mz_m, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      Vrd: new FormControl(dataItem.Vrd, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
    });
  }
}

